// APPOINTMENT — paper-form contact page.
export default function Appointment() {
  return (
    <div className="bg-[#E5DDCB] text-[#1F1E1B] relative">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: 'linear-gradient(#1F1E1B 1px, transparent 1px), linear-gradient(90deg, #1F1E1B 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
      <section className="relative pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1F1E1B]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#6B2D2A] mb-4">— Folio IV · Appointment</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">A first <span className="italic text-[#6B2D2A]">conversation</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#1F1E1B]/65 mt-6 max-w-2xl">An hour, in the back room at no. 14, with a cutter. Without obligation. We do not, and will not, sell you a suit on the spot.</p>
      </section>

      <section className="relative max-w-[1300px] mx-auto px-8 lg:px-14 py-16 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <aside>
          <div className="bg-[#FAF6E8] border border-[#1F1E1B]/20 p-8">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D2A] mb-3">/ The house</p>
            <p className="font-serif text-3xl">14 Savile Row</p>
            <p className="text-sm text-[#1F1E1B]/65 mt-3 leading-[1.7]">Mayfair · London W1S 3PG<br />Mon — Fri · 10:00 — 18:00<br />Saturday by appointment</p>
            <p className="font-mono text-[11px] text-[#1F1E1B]/55 mt-4">+44 20 7493 0184</p>
            <p className="font-mono text-[11px] text-[#6B2D2A] mt-1">house@ashford-vail.com</p>
          </div>
          <p className="text-sm text-[#1F1E1B]/55 leading-[1.7] mt-8 italic">A cutter — Henry, Edmund, or Léa — receives you personally. There is tea. There may, in winter, be a small fire.</p>
        </aside>

        <form className="bg-[#FAF6E8] border border-[#1F1E1B]/20 p-8 lg:p-12 space-y-7" onSubmit={(e) => e.preventDefault()}>
          <div className="border-b-2 border-[#6B2D2A] pb-3 mb-2 flex items-baseline justify-between">
            <span className="font-serif italic text-2xl text-[#6B2D2A]">Form A&V — Appointment</span>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1F1E1B]/55">№ 1923</span>
          </div>
          <PaperField label="Name" testId="tailor-app-name" />
          <div className="grid sm:grid-cols-2 gap-5">
            <PaperField label="Telephone" type="tel" testId="tailor-app-tel" />
            <PaperField label="Email" type="email" testId="tailor-app-email" />
          </div>
          <div>
            <label className="font-serif italic text-base text-[#6B2D2A] block mb-2">Type of commission</label>
            <select data-testid="tailor-app-type" className="w-full bg-transparent border-b-2 border-[#1F1E1B]/25 py-2.5 outline-none focus:border-[#6B2D2A] font-serif text-base text-[#1F1E1B]">
              {['Two-piece suit (single-breasted)', 'Two-piece suit (double-breasted)', 'Three-piece suit', 'Tuxedo / Dinner suit', 'Field jacket / Casual', 'Trousers only', 'Other / unsure'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label className="font-serif italic text-base text-[#6B2D2A] block mb-2">Preferred date</label>
              <input data-testid="tailor-app-date" type="date" className="w-full bg-transparent border-b-2 border-[#1F1E1B]/25 py-2.5 outline-none focus:border-[#6B2D2A] font-serif text-base text-[#1F1E1B]" />
            </div>
            <div>
              <label className="font-serif italic text-base text-[#6B2D2A] block mb-2">Time of day</label>
              <select className="w-full bg-transparent border-b-2 border-[#1F1E1B]/25 py-2.5 outline-none focus:border-[#6B2D2A] font-serif text-base text-[#1F1E1B]">
                {['Morning · 10:00 — 12:00', 'Afternoon · 14:00 — 16:00', 'Late afternoon · 16:00 — 18:00', 'Saturday (by request)'].map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label className="font-serif italic text-base text-[#6B2D2A] block mb-2">A note for the cutter</label>
            <textarea data-testid="tailor-app-note" rows="4" placeholder="Anything you would like us to know — an occasion, a previous house you have used, a cloth you are drawn to." className="w-full bg-transparent border-b-2 border-[#1F1E1B]/25 py-2.5 outline-none focus:border-[#6B2D2A] resize-none font-serif text-base text-[#1F1E1B] placeholder:text-[#1F1E1B]/30" />
          </div>
          <p className="font-serif italic text-sm text-[#1F1E1B]/55 border-t border-[#1F1E1B]/15 pt-4">No fee is charged for the first conversation. Bespoke commissions begin at £8,400.</p>
          <button type="button" data-testid="tailor-app-submit" className="bg-[#6B2D2A] text-[#E5DDCB] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#1F1E1B] transition-colors">Send to the house →</button>
        </form>
      </section>
    </div>
  );
}
function PaperField({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-serif italic text-base text-[#6B2D2A] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b-2 border-[#1F1E1B]/25 py-2.5 outline-none focus:border-[#6B2D2A] font-serif text-base text-[#1F1E1B]" />
    </div>
  );
}
